export default __webpack_public_path__ + "static/media/background-signup.a3a00f89.png";